export default "__VITE_ASSET__hxxrMoxr__"